export enum VehicleMovements {
  OFF = 'off',
  ON = 'work',
}
